import { ACCESS_TOKEN_KEY } from "@config/storageKey";
import { loginSuccess } from "@redux/auth/actions";
import { storageGetItem } from "@utils/storage";
import { call, put, takeLatest } from "redux-saga/effects";
import actionTypes from "../actionTypes";
import authSaga from "./authSaga";
// import actionTypes from '..js'

function checkAuth(token) {
  const rs = {
    data: { access_token: token },
    success: true,
    isLogging: false,
    isLoginSuccess: true,
    isLoginError: false,
  };
  return rs;
}

function* rootSaga() {
  yield takeLatest([actionTypes.DO_LOGIN, actionTypes.DO_LOGOUT], authSaga);
  const accessToken = storageGetItem(ACCESS_TOKEN_KEY);
  if (accessToken) {
    const auth = yield call(checkAuth, accessToken);
    yield put(loginSuccess(auth));
  }
}

export default rootSaga;
